import React from 'react';
import {
    ArrayField,
    BooleanField,
    Datagrid,
    ShowController,
    ShowView,
    Tab,
    TabbedShowLayout,
    TextField } from 'react-admin';

const ConfigTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>{record ? `${record.CustomerName} - ${record.CustomerConfigDescription} ` : ''}</span>;
};

const JSONField = ({ record = {} }) => (<div><pre>{
    JSON.stringify(record.Configuration, null, 2) }</pre></div>);
JSONField.defaultProps = { addLabel: true,};

export const ConfigShow = props => (
    <ShowController   {...props}>
        {controllerProps =>
            <ShowView title={<ConfigTitle />} {...props} {...controllerProps}>
                <TabbedShowLayout>
                    <Tab label = "Configuration">
                        <ArrayField label="Linear Services" source="Configuration.LinearTranscodeServices">
                            <Datagrid>
                                <TextField
                                    label="Input"
                                    source="inputService.xgressSettings.serviceSystemName"
                                    sortable={false}/>
                                <TextField
                                    label="Processing"
                                    source="processing.videoSettings.processingMode"
                                    sortable={false}/>
                                <TextField
                                    label="Profile"
                                    source="processing.videoSettings.encode.profile"
                                    sortable={false}/>
                                <TextField
                                    label="Codec"
                                    source="processing.videoSettings.codec"
                                    sortable={false}/>
                                <BooleanField
                                    label="High Density"
                                    source="processing.videoSettings.encode.highDensity"
                                    sortable={false}/>
                                <TextField
                                    label="rateMode"
                                    source="processing.videoSettings.rateMode"
                                    sortable={false}/>
                                <TextField
                                    label="Resolution"
                                    source="processing.videoSettings.encode.resolutionMode"
                                    sortable={false}/>
                                <TextField
                                    label="esRate"
                                    source="processing.videoSettings.esRate"
                                    sortable={false}/>
                                <TextField
                                    label="vqOptimization"
                                    source="processing.videoSettings.encode.vqOptimization"
                                    sortable={false}/>
                                <TextField
                                    label="GOP Mode"
                                    source="processing.videoSettings.encode.gopMode"
                                    sortable={false}/>
                            </Datagrid>
                        </ArrayField>
                        <ArrayField label="ABR Services" source="Configuration.ABRServices">
                            <Datagrid>
                                <TextField
                                    label="Input"
                                    source="inputService.xgressSettings.serviceSystemName"
                                    sortable={false}/>
                                <TextField
                                    label="Processing"
                                    source="processing.processingType"
                                    sortable={false}/>
                                <ArrayField
                                    label="Profiles"
                                    source="processing.videoSettings.profiles"
                                    sortable={false}>
                                    <Datagrid>
                                        <TextField label="Profile" source="profile" sortable={false}/>
                                        <TextField label="Codec" source="codec" sortable={false}/>
                                        <BooleanField
                                            label="High Density"
                                            source="highDensity"
                                            sortable={false}/>
                                        <TextField label="rateMode" source="rateMode" sortable={false}/>
                                        <TextField label="hRes" source="hResolution" sortable={false}/>
                                        <TextField label="vRes" source="vResolution" sortable={false}/>
                                        <TextField label="frameRate" source="frameRate" sortable={false}/>
                                        <TextField label="esRate" source="esRate" sortable={false}/>
                                        <TextField label="vqOptimization" source="vqOptimization" sortable={false}/>
                                    </Datagrid>
                                </ArrayField>

                            </Datagrid>
                        </ArrayField>
                        <JSONField
                            label="JSON data"
                            source="Configuration"
                            sortable={false}/>

                    </Tab>
                    <Tab label = "TCO information">
                        <TextField label="Channel Count" source="DeployedChannels"/>
                    </Tab>
                    <Tab label="CPU Estimates">
                        <ArrayField label="Test Results" source="Dut">
                            <Datagrid>
                                <TextField
                                    label="Model Name"
                                    source="ModelName"/>
                                <TextField
                                    label="SW Version"
                                    source="SourceVersion"
                                    sortable={false}/>
                                <ArrayField label="Results" source="DensityList">
                                    <Datagrid>
                                        <TextField
                                            label="Density"
                                            source="Density"/>
                                        <TextField
                                            label="Status"
                                            source="TestPassed"/>
                                        <BooleanField
                                            label="Configured"
                                            source="Configured"/>
                                        <TextField
                                            label="Cpu Mean"
                                            source="CpuMean"/>
                                        <TextField
                                            label="pVMAF Mean"
                                            source="pVMAF"/>
                                        <TextField
                                            label="PSNR Mean"
                                            source="PSNR"/>
                                        <TextField
                                            label="Throttle"
                                            source="Throttle"/>
                                        <TextField
                                            label="Throttle HDT"
                                            source="Throttle_HDT"/>
                                        <TextField
                                            label="Power"
                                            source="Power"/>
                                        <BooleanField
                                            label="Clean Start"
                                            source="CleanStart"/>
                                        <ArrayField label="Alarms" source="Alarms">
                                            <Datagrid>
                                                <TextField
                                                    label="Alarm"
                                                    source="Alarm"/>
                                                <TextField
                                                    label="Count"
                                                    source="values"/>
                                            </Datagrid>
                                        </ArrayField>

                                    </Datagrid>
                                </ArrayField>
                            </Datagrid>
                        </ArrayField>
                    </Tab>
                </TabbedShowLayout>
            </ShowView>
        }
    </ShowController>
);

export default (ConfigShow);